import { FloorsContainer } from '../../containers/advancedFilters/FloorsContainer';
import { IFilter } from '../../types/advancedFilters';

export const floors: IFilter = {
  component: FloorsContainer,
};
